import {
  DataGridTextHeaderFilterImpl,
  type DataGridTextHeaderFilterImplProps,
} from "src/components/DataGrid/DataGridTextHeaderFilterImpl.tsx";

export const DataGridTextHeaderFilter = (
  props: DataGridTextHeaderFilterImplProps,
) => {
  // this wrapper exists only to fix hot reloading in this component
  return <DataGridTextHeaderFilterImpl {...props} />;
};
